import { Column } from 'elc-grid';
import styled from 'styled-components';
import { Heading6 } from 'elc-typography';
import { FilterListItemTheme, SelectedFilterListItemTheme } from '../../../theme/default-theme';

export const StyledColumn = styled(Column)`
    padding: 0;
`;
export const FilterList = styled.ul`
    list-style: none;
    display: flex;
    padding-left: 0;
    padding-right: 0;
`;
export const FilterListItem = styled.li`
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 2 1 auto;
`;
export const SelectedFilterListItem = styled(FilterListItem)`
    border-bottom: solid 1px;
`;
export const SelectedFilterHeading = styled(Heading6)`
    ${SelectedFilterListItemTheme};
`;
export const FilterHeading = styled(Heading6)`
    ${FilterListItemTheme};
`;
